import { Component, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { ThemeTogglerComponent } from '../theme-toggler/theme-toggler';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { PlayerBar } from '@shared/components/player-bar/player-bar';
import { PlayerSourceService } from '@shared/components/player-bar/player-source.service';
import { UsersStore } from '@data-access/user/stores/users.store';
import { UserRole } from '@shared/interfacres/user';
import { ApplicationStore } from '@data-access/user/stores/application.store';
import { LibraryStore } from '@data-access/user/stores/library.store';
import { MatDialog } from '@angular/material/dialog';
import { DemoUserHandler } from '@shared/services/demo-user-handler';

@Component({
  selector: 'app-main-layout',
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    ThemeTogglerComponent,
    NgOptimizedImage,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    PlayerBar
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  readonly dialog = inject(MatDialog);
  router = inject(Router);

  UserRoles = UserRole;

  readonly userStore = inject(UsersStore);
  readonly libraryStore = inject(LibraryStore);
  readonly appStore = inject(ApplicationStore);
  readonly demoUserHandlerService = inject(DemoUserHandler);

  playerSource = inject(PlayerSourceService);

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }

  goAdmin() {
    this.router.navigate(['/admin/tracks']);
  }

  async goProfile() {
    const isUserValid = await this.demoUserHandlerService.isUserValid();

    if (!isUserValid) {
      return;
    }
    this.router.navigate(['/profile']);
  }

  goMain() {
    if (!this.userStore.user()) {
      window.location.href = 'https://djmixinglab.com';
      return;
    }
    if (this.userStore.user()?.role === this.UserRoles.Admin) {
      this.router.navigate(['/admin/tracks']);
      return;
    }
    this.router.navigate(['/library']);
  }

  async logout() {
    this.libraryStore.resetDailyDownloads();
    await this.userStore.logout();

  }

}
